import { Component, OnDestroy, OnInit } from '@angular/core';
import { StatsService } from '@app/services/stats.service';
import { MessageService } from 'primeng/api';
import { ITableRow } from '@common/models/Document/ITableRow';
import { Subscription } from 'rxjs';
import { CurrentUserStateService } from '@app/services/currentUserState.service';

@Component({
  selector: 'app-user-stats',
  templateUrl: './user-stats.component.html',
  styleUrls: ['./user-stats.component.scss']
})
export class UserStatsComponent implements OnInit, OnDestroy {

  powerUserSub: Subscription  = new Subscription();
  interactionsVsTime={'chart':{},'loader':true}

  constructor( private statsService: StatsService,
    private messageService: MessageService,
    private readonly currentUserStateService: CurrentUserStateService
  ) {}

  ngOnInit(): void {
    this.getinteractionsVsTime()
  }

  ngOnDestroy() {
    this.powerUserSub &&
    this.powerUserSub.unsubscribe();
  }

  getinteractionsVsTime(){
  this.powerUserSub.add(
    this.statsService.getUserInteractionsVsTime().subscribe(
      (res: ITableRow) => {
        let title={ title: {
          text: `Number of Chat Interactions per quarter for ${this.currentUserStateService.value.name}`,
         top: '3%',
        left: '3%'
        },}
        res={...res,...title}
        this.interactionsVsTime['chart'] = res
        this.interactionsVsTime['loader'] = false
        this.addChatOptions(this.interactionsVsTime)

      },
      (error) => {
              this.interactionsVsTime['loader'] = false
              this.messageService.clear();
              this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: error.error.message,
              });
        }
      )
    )
  }

addChatOptions(chatResp:any){
  let options : ITableRow = {
    grid: {
      left: '10%',
      right: '10%',
      top: '20%',
      bottom: '25%',
    },
    tooltip: {
      trigger: 'axis'
    },
    dataZoom: [
      {
        type: 'slider',
        height: 15,
        xAxisIndex: 0,
        start: 0,
        end: 100,
        bottom: '12%',
      },
      {
        type: 'slider',
        width: 15,
        yAxisIndex: 0,
        start: 0,
        end: 100,
        left: '93%',
        bottom:'28%'
      }
    ],
    toolbox:{
      padding: 15,
      itemSize: 13,
      feature: {
        dataZoom: {
          yAxisIndex: false
        },
        // dataView: { show: true, readOnly: false },
        // magicType: { show: true, type: ['line', 'bar'] },
        restore: { show: true },
        saveAsImage: {
          show : true
        }
      }
    }
  }
  chatResp.chart = {...chatResp.chart,...options}
}

}
